import { render, staticRenderFns } from "./MessageManager.vue?vue&type=template&id=082f9138&"
import script from "./MessageManager.vue?vue&type=script&lang=js&"
export * from "./MessageManager.vue?vue&type=script&lang=js&"
import style0 from "./MessageManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports